<script setup>
import { useAi } from '@/composables/useAi'

// pages/ai/knowledge-base.vue — Module 22 (§29.3). BACA-SAJA — Module 22's
// own Controller/API section tidak menyebut satu route pun untuk
// create/update/delete AiPromptTemplate (hanya Seeder + halaman ini), lihat
// CLAUDE.md § AI Assistant Module. Klik satu template menyalin teksnya ke
// clipboard supaya bisa ditempel di tab Chat.
definePage({
  meta: {
    layout: 'default',
    action: 'chat',
    subject: 'Ai',
  },
})

const { promptTemplates, fetchPromptTemplates } = useAi()

onMounted(fetchPromptTemplates)

const copied = ref(null)

const copyPrompt = async template => {
  await navigator.clipboard?.writeText(template.prompt_template)
  copied.value = template.id
  setTimeout(() => { copied.value = null }, 1500)
}
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-1">
      Knowledge Base &amp; Prompt Library
    </h4>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Prompt template siap pakai — salin ke tab Chat untuk digunakan
    </p>

    <VRow>
      <VCol
        v-for="template in promptTemplates"
        :key="template.id"
        cols="12"
        md="6"
      >
        <VCard>
          <VCardTitle class="d-flex align-center justify-space-between">
            {{ template.title }}
            <VChip
              v-if="template.category"
              size="small"
              variant="tonal"
            >
              {{ template.category }}
            </VChip>
          </VCardTitle>
          <VCardText>
            <p class="text-body-2">
              {{ template.prompt_template }}
            </p>
          </VCardText>
          <VCardActions>
            <VBtn
              size="small"
              variant="tonal"
              :prepend-icon="copied === template.id ? 'ri-check-line' : 'ri-file-copy-line'"
              @click="copyPrompt(template)"
            >
              {{ copied === template.id ? 'Tersalin' : 'Salin' }}
            </VBtn>
          </VCardActions>
        </VCard>
      </VCol>
      <VCol
        v-if="!promptTemplates.length"
        cols="12"
      >
        <p class="text-medium-emphasis text-center py-10">
          Belum ada prompt template.
        </p>
      </VCol>
    </VRow>
  </div>
</template>
